module.exports = __webpack_public_path__ + "static/media/kts01.bfbab515.png";